module.exports = __webpack_public_path__ + "img/alipay.68751806.svg";